/**
 * Figaro — Invoice audit
 * Dashboard table + drop zone; detail = data left / PDF right.
 */

const STYLE_ID = "invoice-audit-styles-v5";

function ensureStyles() {
  for (const id of [
    "invoice-audit-styles-v1",
    "invoice-audit-styles-v2",
    "invoice-audit-styles-v3",
    "invoice-audit-styles-v4",
  ]) {
    document.getElementById(id)?.remove();
  }
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
.ia-shell { max-width: 92rem; margin: 0 auto; }
.ia-shell-wide { max-width: none; width: 100%; margin: 0; padding: 0 .35rem 1rem; box-sizing: border-box; }
.ia-card { background:#fff; border:1px solid #e5e7eb; border-radius:.85rem; box-shadow:0 1px 2px rgba(16,24,40,.04); padding:1rem 1.1rem; overflow:hidden; }
.ia-card-flush { padding:0; }
.ia-drop {
  border:2px dashed #d1d5db; border-radius:1rem; padding:2.25rem 1.5rem; text-align:center;
  color:#6b7280; font-size:.95rem; cursor:pointer; background:#fafafa;
}
.ia-drop:hover, .ia-drop.is-drag { border-color:#b91c1c; background:rgba(185,28,28,.04); color:#111827; }
.ia-drop-title { font-size:1.1rem; font-weight:650; color:#111827; margin-bottom:.35rem; }
.ia-drop-sub { font-size:.82rem; color:#6b7280; }
.ia-log { font-size:.84rem; line-height:1.55; color:#374151; max-height:16rem; overflow:auto; scroll-behavior:smooth; }
.ia-log .ia-log-line { padding:.25rem 0; border-bottom:1px solid #f3f4f6; display:flex; gap:.55rem; }
.ia-log .ia-log-line.is-current { font-weight:650; color:#111827; }
.ia-log .ia-dot { width:.45rem; height:.45rem; border-radius:999px; background:#b91c1c; margin-top:.45rem; flex-shrink:0; animation:ia-pulse 1.1s ease-in-out infinite; }
.ia-log .ia-dot.done { background:#10b981; animation:none; }
.ia-log .ia-dot.err { background:#ef4444; animation:none; }
@keyframes ia-pulse { 0%,100%{ opacity:.35;} 50%{ opacity:1;} }
.ia-table { width:100%; border-collapse:separate; border-spacing:0; font-size:.8125rem; color:#111827; }
.ia-table th { text-align:left; background:#b91c1c; color:#fff; font-size:.68rem; letter-spacing:.05em; text-transform:uppercase; padding:.55rem .7rem; }
.ia-table th:first-child { border-top-left-radius:.85rem; }
.ia-table th:last-child { border-top-right-radius:.85rem; }
.ia-table td { padding:.5rem .7rem; border-bottom:1px solid #e5e7eb; vertical-align:middle; background:#fff; font-size:.8125rem; line-height:1.35; color:#111827; }
.ia-table td.ia-notes { color:#4b5563; }
.ia-table tr:last-child td:first-child { border-bottom-left-radius:.85rem; }
.ia-table tr:last-child td:last-child { border-bottom-right-radius:.85rem; }
.ia-flag { display:inline-flex; min-width:4.1rem; justify-content:center; padding:.12rem .4rem; border-radius:.35rem; font-size:.65rem; font-weight:700; letter-spacing:.03em; text-transform:uppercase; border:1px solid transparent; }
.ia-flag-green { background:#ecfdf5; color:#047857; border-color:#a7f3d0; }
.ia-flag-amber { background:#fffbeb; color:#b45309; border-color:#fcd34d; }
.ia-flag-red { background:#fef2f2; color:#b91c1c; border-color:#fecaca; }
.ia-status {
  display:inline-flex; align-items:center; padding:.12rem .55rem; border-radius:999px;
  font-size:.7rem; font-weight:600; border:1px solid #e5e7eb; background:#f9fafb; color:#374151; white-space:nowrap;
}
.ia-status-approved { background:#ecfdf5; color:#047857; border-color:#a7f3d0; }
.ia-status-rejected { background:#fef2f2; color:#b91c1c; border-color:#fecaca; }
.ia-status-review { background:#fffbeb; color:#b45309; border-color:#fcd34d; }
.ia-status-failed { background:#fef2f2; color:#b91c1c; border-color:#fecaca; }
.ia-status-running { background:#eff6ff; color:#1d4ed8; border-color:#bfdbfe; }
.ia-status-draft { background:#f3f4f6; color:#4b5563; border-color:#e5e7eb; }
.ia-banner { border-radius:.65rem; padding:.55rem .75rem; border:1px solid #e5e7eb; }
.ia-banner-green { background:#ecfdf5; border-color:#a7f3d0; }
.ia-banner-amber { background:#fffbeb; border-color:#fcd34d; }
.ia-banner-red { background:#fef2f2; border-color:#fecaca; }
.ia-btn { display:inline-flex; align-items:center; gap:.35rem; padding:.45rem .8rem; border-radius:.55rem; font-size:.8rem; font-weight:600; border:1px solid #e5e7eb; background:#fff; color:#374151; cursor:pointer; }
.ia-btn:hover { background:#f9fafb; }
.ia-btn-primary { background:#b91c1c; border-color:#b91c1c; color:#fff; }
.ia-btn-primary:hover { background:#991b1b; }
.ia-btn-danger { background:#fff; border-color:#fecaca; color:#b91c1c; }
.ia-btn-danger:hover, .ia-btn.ia-btn-danger.ia-btn-primary, .ia-btn.ia-btn-danger:focus {
  background:#b91c1c; border-color:#b91c1c; color:#fff;
}
.ia-btn:disabled { opacity:.55; cursor:not-allowed; }
.ia-ar { display:inline-flex; align-items:center; gap:.35rem; flex-shrink:0; }
.ia-ar .ia-btn { padding:.35rem .65rem; font-size:.75rem; }
.ia-muted { color:#6b7280; font-size:.78rem; }
.ia-hero-num { font-size:1.25rem; font-weight:700; color:#111827; font-variant-numeric: tabular-nums; text-align:right; }
.ia-hero-total { margin-left:auto; text-align:right; min-width:8rem; }
.ia-val { color:#1d4ed8; font-weight:600; font-size:.875rem; }
.ia-val.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }
.ia-thumbs { display:inline-flex; align-items:center; gap:.25rem; flex-shrink:0; }
.ia-thumb {
  display:inline-flex; align-items:center; justify-content:center; width:1.85rem; height:1.85rem;
  border-radius:.45rem; border:1px solid #e5e7eb; background:#fff; color:#6b7280; cursor:pointer; padding:0;
}
.ia-thumb:hover { background:#f9fafb; }
.ia-thumb.on-up { background:#ecfdf5; border-color:#6ee7b7; color:#047857; }
.ia-thumb.on-down { background:#fef2f2; border-color:#fca5a5; color:#b91c1c; }
.ia-thumb svg { width:1rem; height:1rem; }
.ia-field-input { border:1px solid #e5e7eb; border-radius:.45rem; padding:.3rem .5rem; font-size:.8125rem; min-width:6.5rem; max-width:14rem; }
.ia-field-input.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }
.ia-row-green td:first-child { box-shadow: inset 3px 0 0 #10b981; }
.ia-row-amber td:first-child { box-shadow: inset 3px 0 0 #f59e0b; }
.ia-row-red td:first-child { box-shadow: inset 3px 0 0 #ef4444; }
.ia-table th.num, .ia-table td.num { text-align:right; }
.ia-table td.ia-notes { font-size:.75rem; color:#4b5563; max-width:14rem; }
.ia-icon-btn {
  display:inline-flex; align-items:center; justify-content:center; width:1.9rem; height:1.9rem;
  border-radius:.5rem; border:1px solid #e5e7eb; background:#fff; color:#374151; cursor:pointer; padding:0;
}
.ia-icon-btn:hover { background:#f9fafb; border-color:#d1d5db; }
.ia-icon-btn.danger { color:#b91c1c; }
.ia-icon-btn svg { width:1rem; height:1rem; }
.ia-decision { border-radius:.45rem; border:1px solid #e5e7eb; font-size:.8125rem; font-weight:600; padding:.2rem .35rem; background:#fff; }
.ia-split {
  display:grid;
  grid-template-columns: minmax(18rem, 36%) minmax(0, 1fr);
  gap:.75rem;
  align-items:stretch;
  width:100%;
}
@media (max-width: 1100px) { .ia-split { grid-template-columns: 1fr; } }
.ia-viewer-pane {
  display:flex; flex-direction:column; min-height:calc(100vh - 5.5rem);
  border:1px solid #e5e7eb; border-radius:.85rem; overflow:hidden; background:#111827;
}
.ia-viewer-pane iframe { flex:1; width:100%; min-height:calc(100vh - 5.5rem); border:0; background:#525659; }
.ia-viewer-body { flex:1; display:flex; flex-direction:column; min-height:calc(100vh - 5.5rem); width:100%; overflow:hidden; }
.ia-filters { display:flex; flex-wrap:wrap; gap:.5rem; align-items:center; margin-bottom:.75rem; }
.ia-filters select { border:1px solid #e5e7eb; border-radius:.5rem; padding:.35rem .55rem; font-size:.8rem; background:#fff; }
.ia-inline { display:flex; flex-wrap:wrap; align-items:center; gap:.55rem; width:100%; }
.ia-inline .grow { flex:1; min-width:8rem; }
`;
  document.head.appendChild(style);
}

function svgIcon(name) {
  const common = 'fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"';
  if (name === "pdf") {
    return `<svg viewBox="0 0 24 24" ${common}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2.5a1.5 1.5 0 0 1 0 3H8v2"/><path d="M14 13v5"/><path d="M14 13h1.5a1.5 1.5 0 0 1 0 3H14"/></svg>`;
  }
  if (name === "edit") {
    return `<svg viewBox="0 0 24 24" ${common}><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>`;
  }
  if (name === "trash") {
    return `<svg viewBox="0 0 24 24" ${common}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>`;
  }
  if (name === "mail") {
    return `<svg viewBox="0 0 24 24" ${common}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`;
  }
  if (name === "thumbUp") {
    return `<svg viewBox="0 0 24 24" ${common}><path d="M7 11v10"/><path d="M15 21H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2.4l1.3-6.1A2 2 0 0 1 14.6 3H15a2 2 0 0 1 2 2v4h3a2 2 0 0 1 2 2l-1.2 7.2A2 2 0 0 1 18.8 21H15z"/></svg>`;
  }
  if (name === "thumbDown") {
    return `<svg viewBox="0 0 24 24" ${common}><path d="M17 13V3"/><path d="M9 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.4l-1.3 6.1A2 2 0 0 1 9.4 21H9a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2L3.2 5.8A2 2 0 0 1 5.2 3H9z"/></svg>`;
  }
  return "";
}

function iconBtn(el, { name, title, href, onClick, danger }) {
  const props = {
    class: `ia-icon-btn${danger ? " danger" : ""}`,
    title: title || "",
    type: href ? undefined : "button",
  };
  if (href) props.href = href;
  if (onClick) props.onclick = onClick;
  const node = el(href ? "a" : "button", props);
  node.innerHTML = svgIcon(name);
  return node;
}

let pdfjsLibPromise = null;
async function loadPdfJs() {
  if (pdfjsLibPromise) return pdfjsLibPromise;
  pdfjsLibPromise = import("/v2/pdf.min.mjs")
    .then((mod) => {
      const pdfjs = mod.default || mod;
      if (pdfjs?.GlobalWorkerOptions) {
        pdfjs.GlobalWorkerOptions.workerSrc = "/v2/pdf.worker.min.mjs";
      }
      return pdfjs;
    })
    .catch(() => null);
  return pdfjsLibPromise;
}

/** Full-width pages only — no thumbnail sidebar. */
async function mountInvoicePdfViewer(host, fileUrl) {
  host.replaceChildren();
  const scroll = document.createElement("div");
  scroll.className = "ia-viewer-body";
  scroll.style.cssText =
    "flex:1;overflow:auto;width:100%;background:#525659;padding:.5rem;box-sizing:border-box;";
  const status = document.createElement("div");
  status.style.cssText = "color:#e5e7eb;font-size:.8125rem;padding:.5rem;";
  status.textContent = "Loading PDF…";
  scroll.appendChild(status);
  host.appendChild(scroll);

  const pdfjs = await loadPdfJs();
  if (!pdfjs?.getDocument) {
    const iframe = document.createElement("iframe");
    iframe.src = `${fileUrl}#navpanes=0&scrollbar=1&view=FitH&zoom=page-width`;
    iframe.title = "Invoice PDF";
    iframe.style.cssText = "width:100%;height:100%;min-height:70vh;border:0;";
    host.replaceChildren(iframe);
    return;
  }

  try {
    const res = await fetch(fileUrl, { credentials: "include" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data }).promise;
    scroll.replaceChildren();
    const width = Math.max(320, scroll.clientWidth - 16);

    for (let n = 1; n <= pdf.numPages; n++) {
      const page = await pdf.getPage(n);
      const unscaled = page.getViewport({ scale: 1 });
      const scale = width / unscaled.width;
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement("canvas");
      canvas.width = Math.floor(viewport.width);
      canvas.height = Math.floor(viewport.height);
      canvas.style.cssText =
        "display:block;width:100%;height:auto;margin:0 0 .65rem;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.35);";
      scroll.appendChild(canvas);
      await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
    }
  } catch (e) {
    const iframe = document.createElement("iframe");
    iframe.src = `${fileUrl}#navpanes=0&view=FitH`;
    iframe.title = "Invoice PDF";
    iframe.style.cssText = "width:100%;height:70vh;border:0;";
    host.replaceChildren(iframe);
  }
}

function formatDateDdMmmYy(value) {
  if (value == null || value === "") return "—";
  const raw = String(value).trim();
  // already dd-Mmm-yy-ish
  if (/^\d{1,2}-[A-Za-z]{3}-\d{2}$/.test(raw)) return raw;
  let y, m, d;
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const dmy = raw.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/);
  if (iso) {
    y = Number(iso[1]);
    m = Number(iso[2]);
    d = Number(iso[3]);
  } else if (dmy) {
    d = Number(dmy[1]);
    m = Number(dmy[2]);
    y = Number(dmy[3]);
    if (y < 100) y += 2000;
  } else {
    const ts = Date.parse(raw);
    if (!Number.isFinite(ts)) return raw;
    try {
      return new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "short",
        year: "2-digit",
      }).format(new Date(ts));
    } catch {
      return raw;
    }
  }
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  if (!m || m < 1 || m > 12 || !d) return raw;
  const yy = String(y).slice(-2);
  return `${String(d).padStart(2, "0")}-${months[m - 1]}-${yy}`;
}

function effFlag(row) {
  const u = String(row?.userFlag || "").toLowerCase();
  if (["green", "amber", "red"].includes(u)) return u;
  return String(row?.flag || "amber").toLowerCase();
}

function flagLabel(flag) {
  const f = String(flag || "amber").toLowerCase();
  if (f === "green") return "Approve";
  if (f === "red") return "Reject";
  return "Flag";
}

function money(n, currency) {
  if (n == null || n === "") return "—";
  const v = Number(n);
  if (!Number.isFinite(v)) return "—";
  const s = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${currency} ${s}` : s;
}

function statusMeta(project) {
  if (project.decision === "APPROVED") return { key: "approved", label: "Approved" };
  if (project.decision === "REJECTED") return { key: "rejected", label: "Rejected" };
  if (project.status === "FAILED") return { key: "failed", label: "Failed" };
  if (project.status === "RUNNING") return { key: "running", label: "Running" };
  if (project.matchReport) return { key: "review", label: "Review" };
  if (project.status === "DRAFT") return { key: "draft", label: "Draft" };
  return { key: "draft", label: project.status || "—" };
}

function statusBubble(el, project) {
  const s = statusMeta(project);
  return el("span", { class: `ia-status ia-status-${s.key}`, text: s.label });
}

function decisionSelect(el, currentFlag, onChange) {
  const cur = ["green", "amber", "red"].includes(String(currentFlag || "").toLowerCase())
    ? String(currentFlag).toLowerCase()
    : "amber";
  return el(
    "select",
    { class: "ia-decision", onchange: (e) => onChange(e.target.value) },
    [
      el("option", { value: "green", text: "Approve", selected: cur === "green" }),
      el("option", { value: "amber", text: "Flag", selected: cur === "amber" }),
      el("option", { value: "red", text: "Reject", selected: cur === "red" }),
    ]
  );
}

function invoiceDecisionSelect(el, decision, onChange) {
  const cur = String(decision || "").toUpperCase();
  return el(
    "select",
    { class: "ia-decision", onchange: (e) => onChange(e.target.value || null) },
    [
      el("option", { value: "", text: "Pending", selected: !cur }),
      el("option", { value: "APPROVED", text: "Approve invoice", selected: cur === "APPROVED" }),
      el("option", { value: "REJECTED", text: "Reject invoice", selected: cur === "REJECTED" }),
    ]
  );
}

/** Thumbs up / down — proposed value confirmed or rejected; always visible to change. */
function thumbs(el, currentFlag, { onUp, onDown }) {
  const cur = ["green", "amber", "red"].includes(String(currentFlag || "").toLowerCase())
    ? String(currentFlag).toLowerCase()
    : "";
  const up = el("button", {
    type: "button",
    class: `ia-thumb${cur === "green" ? " on-up" : ""}`,
    title: "Confirm",
    onclick: () => onUp(),
  });
  up.innerHTML = svgIcon("thumbUp");
  const down = el("button", {
    type: "button",
    class: `ia-thumb${cur === "red" ? " on-down" : ""}`,
    title: "Reject",
    onclick: () => onDown(),
  });
  down.innerHTML = svgIcon("thumbDown");
  return el("div", { class: "ia-thumbs" }, [up, down]);
}

const CONCUR_INVOICE_TO = "daeinvoice@concursolutions.com";

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

function wrapBase64(b64, width = 76) {
  const s = String(b64 || "").replace(/\s+/g, "");
  const lines = [];
  for (let i = 0; i < s.length; i += width) lines.push(s.slice(i, i + width));
  return lines.join("\r\n");
}

function invoiceDocIdFromProject(project) {
  const docs = project?.documents || [];
  const inv = docs.find((d) => d.role === "INVOICE");
  return inv?.documentId || docs[0]?.documentId || null;
}

function concurEmailSubject({ poNumber, invoiceNumber }) {
  const po = String(poNumber || "").trim() || "—";
  const inv = String(invoiceNumber || "").trim() || "—";
  return `PO # ${po} | INVOICE ${inv}`;
}

function concurAttachmentName(subject) {
  const base = String(subject || "invoice")
    .replace(/\|/g, "-")
    .replace(/\s+/g, " ")
    .trim();
  return `${base}.pdf`;
}

function buildConcurInvoiceEmailHtml({
  poNumber,
  vendor,
  amount,
  currency,
  invoiceDate,
  invoiceNumber,
  msn,
} = {}) {
  const subject = concurEmailSubject({ poNumber, invoiceNumber });
  const th =
    "padding:8px 10px;text-align:left;font-size:12px;background:#f9fafb;border:1px solid #e5e7eb;color:#374151;font-weight:600;";
  const td =
    "padding:8px 10px;font-size:13px;border:1px solid #e5e7eb;color:#111827;";
  const msnLine = msn
    ? `<p style="font-size:14px;margin:0 0 12px;line-height:1.5;color:#374151;">Aircraft MSN: <strong>${escapeHtml(msn)}</strong></p>`
    : "";
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#f3f4f6;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f3f4f6;padding:24px 12px;">
    <tr><td align="center">
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="max-width:640px;background:#ffffff;border:1px solid #e5e7eb;border-radius:4px;overflow:hidden;">
        <tr><td style="padding:20px 22px 8px;font-family:Calibri,Arial,sans-serif;">
          <p style="font-size:14px;margin:0 0 12px;color:#111827;">Dear Accounts Payable,</p>
          <p style="font-size:14px;margin:0 0 12px;line-height:1.5;color:#374151;">Please find attached the invoice for processing.</p>
          ${msnLine}
        </td></tr>
        <tr><td style="padding:0 22px 18px;font-family:Calibri,Arial,sans-serif;">
          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;border:1px solid #e5e7eb;">
            <tbody>
              <tr><th style="${th}">PO</th><td style="${td}">${escapeHtml(poNumber || "—")}</td></tr>
              <tr><th style="${th}">Vendor</th><td style="${td}">${escapeHtml(vendor || "—")}</td></tr>
              <tr><th style="${th}">Amount</th><td style="${td}">${escapeHtml(amount || "—")}</td></tr>
              <tr><th style="${th}">Currency</th><td style="${td}">${escapeHtml(currency || "—")}</td></tr>
              <tr><th style="${th}">Invoice date</th><td style="${td}">${escapeHtml(invoiceDate || "—")}</td></tr>
            </tbody>
          </table>
        </td></tr>
        <tr><td style="padding:4px 22px 20px;font-family:Calibri,Arial,sans-serif;">
          <p style="font-size:13px;color:#374151;margin:0;">Thank you,</p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body></html>`;
  return { subject, html };
}

function buildConcurInvoiceEml({ to, subject, html, attachmentName, attachmentBase64 }) {
  const boundary = `----=_Actracker_Invoice_${Date.now()}`;
  const safeAtt = String(attachmentName || "invoice.pdf").replace(/"/g, "");
  const lines = [
    "MIME-Version: 1.0",
    "X-Unsent: 1",
    "From: ",
    `To: ${to}`,
    `Subject: ${subject}`,
    `Content-Type: multipart/mixed; boundary="${boundary}"`,
    "",
    `--${boundary}`,
    "Content-Type: text/html; charset=utf-8",
    "Content-Transfer-Encoding: 8bit",
    "",
    html,
    `--${boundary}`,
    `Content-Type: application/pdf; name="${safeAtt}"`,
    `Content-Disposition: attachment; filename="${safeAtt}"`,
    "Content-Transfer-Encoding: base64",
    "",
    wrapBase64(attachmentBase64),
    `--${boundary}--`,
    "",
  ];
  return new Blob([lines.join("\r\n")], { type: "message/rfc822" });
}

function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 8000);
}

async function downloadConcurInvoiceEml({ apiUrl, docId, project, formatDateDdMmmYy, money }) {
  const ex = project.extract || {};
  const report = project.matchReport || {};
  const po = report.poCheck?.poNumber || ex.poNumber || "";
  const invNo = project.invoiceNumber || ex.invoiceNumber || "";
  const currency = (ex.currency || project.currency || "USD").toUpperCase();
  const { subject, html } = buildConcurInvoiceEmailHtml({
    poNumber: po,
    vendor: ex.vendor || project.vendorName || "",
    amount: money(ex.total),
    currency,
    invoiceDate: formatDateDdMmmYy(ex.invoiceDate),
    invoiceNumber: invNo,
    msn: ex.msn || "",
  });
  const attName = concurAttachmentName(subject);
  const res = await fetch(apiUrl(`/api/ai/documents/${docId}/file`), { credentials: "include" });
  if (!res.ok) throw new Error(`Could not load invoice PDF (HTTP ${res.status})`);
  const buf = await res.arrayBuffer();
  const blob = buildConcurInvoiceEml({
    to: CONCUR_INVOICE_TO,
    subject,
    html,
    attachmentName: attName,
    attachmentBase64: arrayBufferToBase64(buf),
  });
  const emlName = `${attName.replace(/\.pdf$/i, "")}.eml`.replace(/[^\w.\- #]+/g, "_");
  downloadBlob(blob, emlName);
}

async function streamAnalyze(apiUrl, projectId, handlers) {
  const response = await fetch(apiUrl(`/api/ai/invoice-audit/${projectId}/analyze`), {
    method: "POST",
    credentials: "include",
    headers: { Accept: "text/event-stream" },
  });
  if (response.status === 401) {
    window.location.href = "/login.html";
    throw new Error("Session expired");
  }
  if (!response.ok || !response.body) throw new Error(`HTTP ${response.status}`);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let finished = false;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let split;
    while ((split = buffer.indexOf("\n\n")) >= 0) {
      const frame = buffer.slice(0, split);
      buffer = buffer.slice(split + 2);
      let event = "message";
      const data = [];
      for (const line of frame.split("\n")) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) data.push(line.slice(5).trim());
      }
      if (!data.length) continue;
      let payload;
      try {
        payload = JSON.parse(data.join("\n"));
      } catch {
        continue;
      }
      if (event === "step") handlers.onStep?.(payload);
      else if (event === "done") {
        finished = true;
        handlers.onDone?.(payload);
      } else if (event === "failed") {
        finished = true;
        handlers.onFail?.(payload);
      }
    }
  }
  if (!finished) handlers.onFail?.({ error: "Connection closed before audit finished" });
}

export function renderInvoiceAuditRoute({ el, fetchJson, apiUrl, cleanText, routeKey }) {
  ensureStyles();
  const raw = String(routeKey || "").replace(/^figaro\/?/, "");
  const parts = raw.split("/").filter(Boolean);
  const rest = parts.slice(1);
  const isDetail = rest[0] && /^\d+$/.test(rest[0]);
  const host = el("div", { class: isDetail ? "space-y-3 ia-shell-wide" : "space-y-4 ia-shell" });
  if (isDetail) {
    paintDetail({ el, fetchJson, apiUrl, cleanText, host, id: Number(rest[0]) });
  } else {
    paintHome({ el, fetchJson, apiUrl, cleanText, host });
  }
  return host;
}

function titleFromFilename(name) {
  return (
    String(name || "Invoice")
      .replace(/\.[^.]+$/, "")
      .replace(/[_-]+/g, " ")
      .slice(0, 120)
      .trim() || "Invoice audit"
  );
}

function paintHome({ el, fetchJson, apiUrl, cleanText, host }) {
  const status = el("div", { class: "ia-muted mt-3 min-h-[1.25rem]" });
  const fileInput = el("input", {
    type: "file",
    multiple: true,
    accept: ".pdf,.xlsx,.xls,.xlsm,.docx,.png,.jpg,.jpeg,.txt,.eml",
    class: "hidden",
  });
  const drop = el("div", { class: "ia-drop" }, [
    el("div", { class: "ia-drop-title", text: "Drop an invoice here" }),
    el("div", { class: "ia-drop-sub", text: "PDF · audit starts automatically" }),
  ]);

  async function handleFiles(fileList) {
    const files = [...(fileList || [])];
    if (!files.length) return;
    drop.classList.remove("is-drag");
    status.textContent = `Uploading ${files.length} file(s)…`;
    drop.style.pointerEvents = "none";
    drop.style.opacity = "0.65";
    try {
      const created = await fetchJson(apiUrl("/api/ai/invoice-audit"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title: titleFromFilename(files[0].name) }),
      });
      const id = created.project?.id;
      if (!id) throw new Error("Could not create audit");
      for (let i = 0; i < files.length; i++) {
        const f = files[i];
        const name = String(f.name || "").toLowerCase();
        let role = i === 0 ? "INVOICE" : /\bpo\b|purchase.?order/.test(name) ? "PURCHASE_ORDER" : "ANNEX";
        const fd = new FormData();
        fd.append("role", role);
        fd.append("files", f);
        await fetchJson(apiUrl(`/api/ai/invoice-audit/${id}/upload`), { method: "POST", body: fd });
      }
      location.hash = `#/figaro/invoice-audit/${id}?run=1`;
    } catch (e) {
      status.textContent = cleanText(e?.message) || String(e);
      drop.style.pointerEvents = "";
      drop.style.opacity = "";
    }
  }

  drop.onclick = () => fileInput.click();
  drop.ondragover = (e) => {
    e.preventDefault();
    drop.classList.add("is-drag");
  };
  drop.ondragleave = () => drop.classList.remove("is-drag");
  drop.ondrop = (e) => {
    e.preventDefault();
    void handleFiles(e.dataTransfer?.files);
  };
  fileInput.onchange = () => void handleFiles(fileInput.files);

  const tableHost = el("div", { class: "mt-6" });
  host.replaceChildren(
    el("div", { class: "space-y-4" }, [
      el("div", {}, [
        el("h1", { class: "text-xl font-semibold text-gray-900", text: "Invoice audit" }),
        el("p", { class: "ia-muted mt-1", text: "Drop an invoice to audit. Follow up from the table." }),
      ]),
      drop,
      fileInput,
      status,
      tableHost,
    ])
  );

  let allProjects = [];
  let filterVendor = "";
  let filterStatus = "";

  function renderTable() {
    const vendors = [...new Set(allProjects.map((p) => p.vendorName || p.extract?.vendor).filter(Boolean))].sort();
    const filtered = allProjects.filter((p) => {
      const vendor = p.vendorName || p.extract?.vendor || "";
      const st = statusMeta(p).key;
      if (filterVendor && vendor !== filterVendor) return false;
      if (filterStatus && st !== filterStatus) return false;
      return true;
    });

    const vendorSel = el(
      "select",
      {
        onchange: (e) => {
          filterVendor = e.target.value;
          renderTable();
        },
      },
      [
        el("option", { value: "", text: "All vendors", selected: !filterVendor }),
        ...vendors.map((v) => el("option", { value: v, text: v, selected: filterVendor === v })),
      ]
    );
    const statusSel = el(
      "select",
      {
        onchange: (e) => {
          filterStatus = e.target.value;
          renderTable();
        },
      },
      [
        el("option", { value: "", text: "All statuses", selected: !filterStatus }),
        ...["review", "approved", "rejected", "running", "failed", "draft"].map((k) =>
          el("option", {
            value: k,
            text: k.charAt(0).toUpperCase() + k.slice(1),
            selected: filterStatus === k,
          })
        ),
      ]
    );

    if (!allProjects.length) {
      tableHost.replaceChildren(el("div", { class: "ia-muted", text: "No invoices audited yet." }));
      return;
    }

    tableHost.replaceChildren(
      el("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2", text: "Processed invoices" }),
      el("div", { class: "ia-filters" }, [
        el("span", { class: "ia-muted", text: "Filter" }),
        vendorSel,
        statusSel,
      ]),
      el("div", { class: "ia-card ia-card-flush" }, [
        el("table", { class: "ia-table" }, [
          el("thead", {}, [
            el("tr", {}, [
              el("th", { text: "Invoice #" }),
              el("th", { text: "MSN" }),
              el("th", { text: "Vendor" }),
              el("th", { class: "num", text: "Total" }),
              el("th", { text: "Currency" }),
              el("th", { text: "Invoice date" }),
              el("th", { text: "DAE PO#" }),
              el("th", { text: "Status" }),
              el("th", { text: "Actions" }),
            ]),
          ]),
          el(
            "tbody",
            {},
            filtered.map((p) => {
              const ex = p.extract || {};
              const invNo =
                p.invoiceNumber ||
                p.matchReport?.invoiceNumberCheck?.value ||
                ex.invoiceNumber ||
                null;
              const msn = p.matchReport?.msnCheck?.value || ex.msn || "—";
              const po = ex.poNumber || p.matchReport?.poCheck?.poNumber || "—";
              const cur = (p.currency || ex.currency || "—").toString().toUpperCase();
              return el("tr", {}, [
                el("td", {
                  class: "font-semibold font-mono",
                  text: invNo ? String(invNo) : "—",
                }),
                el("td", { class: "font-mono", text: msn }),
                el("td", { text: p.vendorName || ex.vendor || "—" }),
                el("td", { class: "num font-medium tabular-nums", text: money(ex.total) }),
                el("td", { text: cur }),
                el("td", { text: formatDateDdMmmYy(ex.invoiceDate) }),
                el("td", { class: "font-mono", text: String(po) }),
                el("td", {}, [statusBubble(el, p)]),
                el("td", {}, [
                  el("div", { class: "flex items-center gap-1.5" }, [
                    iconBtn(el, {
                      name: "pdf",
                      title: "Open invoice",
                      href: `#/figaro/invoice-audit/${p.id}`,
                    }),
                    iconBtn(el, {
                      name: "edit",
                      title: "Edit / review",
                      href: `#/figaro/invoice-audit/${p.id}`,
                    }),
                    p.decision === "APPROVED"
                      ? iconBtn(el, {
                          name: "mail",
                          title: `Email to ${CONCUR_INVOICE_TO}`,
                          onClick: async () => {
                            try {
                              const data = await fetchJson(apiUrl(`/api/ai/invoice-audit/${p.id}`));
                              const full = data.project || data;
                              const dId = invoiceDocIdFromProject(full);
                              if (!dId) throw new Error("No invoice PDF linked");
                              await downloadConcurInvoiceEml({
                                apiUrl,
                                docId: dId,
                                project: full,
                                formatDateDdMmmYy,
                                money,
                              });
                            } catch (e) {
                              window.alert(cleanText(e?.message) || String(e));
                            }
                          },
                        })
                      : null,
                    iconBtn(el, {
                      name: "trash",
                      title: "Delete",
                      danger: true,
                      onClick: async () => {
                        if (!window.confirm("Delete this invoice audit?")) return;
                        await fetchJson(apiUrl(`/api/ai/invoice-audit/${p.id}`), { method: "DELETE" });
                        allProjects = allProjects.filter((x) => x.id !== p.id);
                        renderTable();
                      },
                    }),
                  ].filter(Boolean)),
                ]),
              ]);
            })
          ),
        ]),
      ])
    );
  }

  void (async () => {
    try {
      const data = await fetchJson(apiUrl("/api/ai/invoice-audit"));
      allProjects = data.projects || [];
      renderTable();
    } catch (e) {
      tableHost.replaceChildren(
        el("div", { class: "text-sm text-red-700", text: cleanText(e?.message) || String(e) })
      );
    }
  })();
}

function paintDetail({ el, fetchJson, apiUrl, cleanText, host, id }) {
  let project = null;
  let running = false;
  const root = el("div", { class: "space-y-4" });
  host.replaceChildren(root);

  const wantRun =
    typeof location !== "undefined" &&
    (/[?&]run=1\b/.test(location.hash) || /[?&]run=1\b/.test(location.search || ""));

  async function reload() {
    const data = await fetchJson(apiUrl(`/api/ai/invoice-audit/${id}`));
    project = data.project;
    return project;
  }

  function invoiceDocId() {
    return invoiceDocIdFromProject(project);
  }

  function paintProgress(lines, { error } = {}) {
    const inv =
      project?.invoiceNumber ||
      project?.extract?.invoiceNumber ||
      null;
    root.replaceChildren(
      el("div", { class: "space-y-4" }, [
        el("a", { href: "#/figaro/invoice-audit", class: "ia-btn", text: "← Invoices dashboard" }),
        el("h1", {
          class: "text-xl font-semibold text-gray-900 font-mono tracking-tight",
          text: inv ? `Invoice ${inv}` : project?.title || `Audit #${id}`,
        }),
        el("div", { class: "ia-card" }, [
          el("div", {
            class: "text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2",
            text: "Working",
          }),
          el(
            "div",
            { class: "ia-log", id: "ia-progress-log" },
            lines.map((line, i) =>
              el("div", { class: `ia-log-line${i === lines.length - 1 && !error ? " is-current" : ""}` }, [
                el("span", {
                  class: `ia-dot${error && i === lines.length - 1 ? " err" : i < lines.length - 1 || error ? " done" : ""}`,
                }),
                el("span", { text: line }),
              ])
            )
          ),
          error ? el("div", { class: "mt-3 text-sm text-red-700", text: error }) : null,
        ].filter(Boolean)),
      ])
    );
    // Always keep the latest step visible
    requestAnimationFrame(() => {
      const logEl = document.getElementById("ia-progress-log");
      if (logEl) logEl.scrollTop = logEl.scrollHeight;
    });
  }

  function paintReport() {
    const ex = project.extract || {};
    const report = project.matchReport || {};
    const po = report.poCheck || {};
    const bill = report.billToCheck || {};
    const invCheck = report.invoiceNumberCheck || {};
    const msnCheck = report.msnCheck || {};
    const rows = report.rows || [];
    const poF = effFlag(po);
    const billF = effFlag(bill);
    const invF = effFlag(invCheck);
    const msnF = effFlag(msnCheck);
    const docId = invoiceDocId();
    const currency = (ex.currency || project.currency || "USD").toUpperCase();

    const invNo = project.invoiceNumber || invCheck.value || ex.invoiceNumber || null;
    const msn = msnCheck.value || ex.msn || null;
    const approved = project.decision === "APPROVED";

    async function postReview(body) {
      await fetchJson(apiUrl(`/api/ai/invoice-audit/${id}/review`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      await reload();
      paintReport();
    }

    async function decideInvoice(decision) {
      if (!decision) {
        await postReview({ decision: null });
        return;
      }
      await fetchJson(apiUrl(`/api/ai/invoice-audit/${id}/review`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ decision }),
      });
      try {
        await fetchJson(apiUrl(`/api/ai/invoice-audit/${id}/learn`), { method: "POST" });
      } catch {
        /* ignore */
      }
      location.hash = "#/figaro/invoice-audit";
    }

    function fieldRow({ flag, label, value, inputId, inputValue, placeholder, mono, wide, onThumb }) {
      return el("div", { class: `ia-banner ia-banner-${flag || "amber"}` }, [
        el("div", { class: "ia-inline" }, [
          el("span", { class: "font-semibold text-sm", text: label }),
          el("span", {
            class: `ia-val grow${mono ? " mono" : ""}`,
            text: value || "—",
          }),
          el("input", {
            id: inputId,
            class: `ia-field-input${mono ? " mono" : ""}${wide ? "" : ""}`,
            style: wide ? "min-width:10rem;max-width:18rem;flex:1;" : undefined,
            placeholder: placeholder || "",
            value: inputValue || "",
          }),
          thumbs(el, flag, {
            onUp: () => onThumb("green"),
            onDown: () => onThumb("red"),
          }),
        ]),
      ]);
    }

    const left = el("div", { class: "space-y-3" }, [
      el("div", { class: "flex flex-wrap items-start justify-between gap-2" }, [
        el("div", {}, [
          el("h1", {
            class: "text-xl font-semibold text-gray-900 font-mono tracking-tight",
            text: invNo ? `Invoice ${invNo}` : project.title || `Audit #${id}`,
          }),
          el("div", {
            class: "ia-muted mt-0.5",
            text: [
              ex.vendor || project.vendorName || null,
              msn ? `MSN ${msn}` : null,
              formatDateDdMmmYy(ex.invoiceDate),
              `Currency ${currency}`,
            ]
              .filter(Boolean)
              .join(" · "),
          }),
        ]),
        el("div", { class: "ia-hero-total" }, [
          el("div", { class: "ia-muted", text: `Total (${currency})` }),
          el("div", { class: "ia-hero-num", text: money(ex.total, currency) }),
          statusBubble(el, project),
        ]),
      ]),

      fieldRow({
        flag: invF,
        label: "Invoice #",
        value: invNo,
        inputId: "ia-inv-input",
        inputValue: invNo || "",
        placeholder: "e.g. RC-2026-10",
        mono: true,
        onThumb: async (v) => {
          const typed = document.getElementById("ia-inv-input")?.value;
          const payload = { invoiceNumberCheck: { userFlag: v } };
          if (typed && String(typed).trim()) payload.manualInvoiceNumber = typed;
          await postReview(payload);
        },
      }),

      fieldRow({
        flag: msnF,
        label: "MSN",
        value: msn,
        inputId: "ia-msn-input",
        inputValue: msn || "",
        placeholder: "e.g. 4548",
        mono: true,
        onThumb: async (v) => {
          const typed = document.getElementById("ia-msn-input")?.value;
          const payload = { msnCheck: { userFlag: v } };
          if (typed && String(typed).trim()) payload.manualMsn = typed;
          await postReview(payload);
        },
      }),

      fieldRow({
        flag: poF,
        label: "DAE PO#",
        value: po.poNumber || ex.poNumber,
        inputId: "ia-po-input",
        inputValue: po.poNumber || ex.poNumber || "",
        placeholder: "77921",
        mono: true,
        onThumb: async (v) => {
          const typed = document.getElementById("ia-po-input")?.value;
          const payload = { poCheck: { userFlag: v } };
          if (typed && String(typed).trim()) payload.manualPoNumber = typed;
          await postReview(payload);
        },
      }),

      fieldRow({
        flag: billF,
        label: "Bill To",
        value: bill.invoiceBillTo || ex.billTo,
        inputId: "ia-bill-input",
        inputValue: bill.invoiceBillTo || ex.billTo || "",
        placeholder: "Bill-to party",
        wide: true,
        onThumb: async (v) => {
          const typed = document.getElementById("ia-bill-input")?.value;
          const payload = { billToCheck: { userFlag: v } };
          if (typed && String(typed).trim()) payload.billToCheck.invoiceBillTo = typed;
          await postReview(payload);
        },
      }),

      report.exchangeRate?.rate
        ? el("div", {
            class: "ia-muted",
            text: `FX 1 ${report.exchangeRate.from || "USD"} = ${report.exchangeRate.rate} ${
              report.exchangeRate.to || "MXN"
            }`,
          })
        : el("div", { class: "ia-muted", text: `Currency ${currency}` }),

      el("div", { class: "ia-card ia-card-flush overflow-x-auto" }, [
        el("div", {
          class: "px-3 py-2 font-semibold text-sm border-b border-gray-100",
          text: "Itemization",
        }),
        rows.length
          ? el("table", { class: "ia-table" }, [
              el("thead", {}, [
                el("tr", {}, [
                  el("th", { text: "Decision" }),
                  el("th", { text: "Description" }),
                  el("th", { class: "num", text: `Amount (${currency})` }),
                  el("th", { class: "num", text: "Support" }),
                  el("th", { text: "Notes" }),
                ]),
              ]),
              el(
                "tbody",
                {},
                rows.map((r) => {
                  const f = effFlag(r);
                  const line = (ex.lineItems || []).find((l) => l.id === r.lineId);
                  const desc = line?.description || r.description || r.lineId;
                  const support =
                    r.amountSupported != null
                      ? money(r.amountSupported, currency)
                      : line?.supportKind
                        ? money(r.amountInvoice, currency)
                        : "—";
                  return el("tr", { class: `ia-row-${f}` }, [
                    el("td", {}, [
                      decisionSelect(el, r.userFlag || r.flag, async (v) => {
                        await postReview({
                          rowOverrides: [{ lineId: r.lineId, userFlag: v }],
                        });
                      }),
                    ]),
                    el("td", { text: desc }),
                    el("td", { class: "num tabular-nums", text: money(r.amountInvoice, currency) }),
                    el("td", { class: "num tabular-nums", text: support }),
                    el("td", {
                      class: "ia-notes",
                      text: r.reason || line?.notes || "—",
                    }),
                  ]);
                })
              ),
            ])
          : el("div", { class: "p-4 ia-muted", text: "No lines — re-run." }),
      ]),

      el("div", { class: "flex flex-wrap gap-2 items-center" }, [
        el("span", { class: "text-sm font-semibold text-gray-700", text: "Invoice" }),
        invoiceDecisionSelect(el, project.decision, (v) => void decideInvoice(v || null)),
        approved && docId
          ? iconBtn(el, {
              name: "mail",
              title: `Email to ${CONCUR_INVOICE_TO}`,
              onClick: async () => {
                try {
                  await downloadConcurInvoiceEml({
                    apiUrl,
                    docId,
                    project,
                    formatDateDdMmmYy,
                    money,
                  });
                } catch (e) {
                  window.alert(cleanText(e?.message) || String(e));
                }
              },
            })
          : null,
        el("button", {
          type: "button",
          class: "ia-btn",
          text: "Re-run",
          onclick: () => void startRun(),
        }),
      ].filter(Boolean)),
    ]);

    const viewerBody = el("div", { class: "ia-viewer-body" });
    const right = docId
      ? el("div", { class: "ia-viewer-pane" }, [
          el("div", {
            class:
              "px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500 bg-white border-b border-gray-100",
            text: "Invoice PDF · full width",
          }),
          viewerBody,
          ex.ocrQuality?.score && ex.ocrQuality.score !== "good"
            ? el("div", {
                class: "px-3 py-1.5 text-xs text-amber-800 bg-amber-50 border-t border-amber-100",
                text: `OCR ${ex.ocrQuality.score}: ${(ex.ocrQuality.warnings || [])[0] || "Verify in PDF"}`,
              })
            : null,
        ].filter(Boolean))
      : el("div", { class: "ia-card ia-muted", text: "No invoice file linked." });

    root.replaceChildren(
      el("div", { class: "space-y-3" }, [
        el("a", { href: "#/figaro/invoice-audit", class: "ia-btn", text: "← Invoices dashboard" }),
        el("div", { class: "ia-split" }, [left, right]),
      ])
    );

    if (docId) {
      void mountInvoicePdfViewer(viewerBody, apiUrl(`/api/ai/documents/${docId}/file`));
    }
  }

  async function startRun() {
    if (running) return;
    running = true;
    const lines = ["Starting…"];
    paintProgress(lines);
    try {
      await streamAnalyze(apiUrl, id, {
        onStep: (step) => {
          const msg = step?.message || "Working…";
          if (lines[lines.length - 1] !== msg) lines.push(msg);
          paintProgress(lines);
        },
        onDone: async (payload) => {
          project = payload?.project || (await reload());
          running = false;
          if (typeof history !== "undefined" && location.hash.includes("run=1")) {
            history.replaceState(null, "", `#/figaro/invoice-audit/${id}`);
          }
          paintReport();
        },
        onFail: async (payload) => {
          running = false;
          try {
            await reload();
          } catch {
            /* ignore */
          }
          paintProgress(lines, { error: payload?.error || "Audit failed" });
        },
      });
    } catch (e) {
      running = false;
      paintProgress(lines, { error: cleanText(e?.message) || String(e) });
    }
  }

  void (async () => {
    try {
      await reload();
      // Never auto-rerun an already approved/rejected invoice (deploy must not wipe review)
      const decided = project.decision === "APPROVED" || project.decision === "REJECTED";
      const needsRun =
        wantRun ||
        (!decided && (!project.matchReport || project.status === "FAILED" || project.status === "DRAFT"));
      if (needsRun) await startRun();
      else paintReport();
    } catch (e) {
      root.replaceChildren(
        el("div", { class: "text-sm text-red-700", text: cleanText(e?.message) || String(e) })
      );
    }
  })();
}
